import { types } from 'mobx-state-tree';
import WeaponQualityModel from "./weaponQualityModel";

const WeaponQualitiesStore = types.model('WeaponQualitiesStore', {
    data: types.array(WeaponQualityModel)
}).actions(self => ({
    add(item) {
        self.data.push({ ...item });
    }
})).views(self => ({
    getByGuid(id) {
        return self.data.find(item => item.guidStr === id);
    }
}));

export default WeaponQualitiesStore;
